import React from 'react';

import { formatMoney } from '@betterment/core';
import { useGraphQLQuery } from '@betterment/graphql';
import { track, useToggledValue } from '@betterment/js-runtime';
import { Box, Button, Card, Heading, Separator, Text } from '@betterment/samba-react';

import { NetWorthDocument } from './graphql/query.netWorth.generated';
import { NetWorthModal } from './NetWorthModal';

import { CompactCardLoader } from '../../Shared/components-v2/shimmer-loaders/compact-card-loader';

const NetWorthCard: React.FC = () => {
  const { data } = useGraphQLQuery(NetWorthDocument, { throwOnError: true });

  const [isNetWorthModalOpen, toggleModalOpen] = useToggledValue(false);

  const breakdownOnClick = () => {
    toggleModalOpen();
    track('ElementClicked', {
      location: 'Summary',
      module: 'NetWorth',
      name: 'ShowBreakdown',
    });
  };

  if (!data) return <CompactCardLoader />;

  if (!data.netWorth) return null;

  return (
    <Card>
      <Card.Header css={{ padding: 'space.300', display: 'flex', justifyContent: 'space-between' }}>
        <Heading as="h2" variant="title200">
          Net worth
        </Heading>
        <Button variant="textPrimary" onClick={breakdownOnClick}>
          See breakdown
        </Button>
      </Card.Header>
      <Separator css={{ fullWidthWithInset: 'space.300' }} />
      <Card.Content css={{ padding: 'space.300' }}>
        <Box
          css={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 'space.100',
          }}
        >
          <Text>Total net worth</Text>
          <Text>{formatMoney(data.netWorth.balance)}</Text>
        </Box>
        <Box css={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Text>{data.netWorth.internalSubtotal.name} balance</Text>
          <Text>{formatMoney(data.netWorth.internalSubtotal.balance)}</Text>
        </Box>
      </Card.Content>
      {isNetWorthModalOpen && <NetWorthModal closeHandler={toggleModalOpen} netWorth={data.netWorth} />}
    </Card>
  );
};

export default NetWorthCard;
